import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/components/vss/data";

export default function Services() {
  return (
    <section
      id="services"
      className="relative py-28 sm:py-36 border-t border-slate-200 bg-slate-50/60"
      data-testid="services-section"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-6">
            <div className="mb-3 font-mono-a text-[11px] uppercase tracking-[0.28em] text-teal-700">
              / 003 · Engagement Models
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-[1.05]">
              Five ways to plug in
              <br />
              <span className="font-serif-a italic font-normal text-slate-500">
                validated talent.
              </span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:col-start-8">
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
              Flexible engagement blueprints designed around real enterprise
              velocity — contingent surge, outcome-based delivery, culture-fit
              trials, dedicated pods, and custom bootcamp pipelines.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 sm:gap-5">
          {SERVICES.map((s, i) => {
            const spans = [
              "lg:col-span-7",
              "lg:col-span-5",
              "lg:col-span-4",
              "lg:col-span-4",
              "lg:col-span-4",
            ];
            return (
              <motion.a
                key={s.idx}
                href="#contact"
                initial={{ opacity: 0, y: 26 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10% 0px" }}
                transition={{ delay: i * 0.06, duration: 0.7, ease: "easeOut" }}
                className={`vss-card group relative col-span-12 sm:col-span-6 ${spans[i]} p-8 sm:p-10 min-h-[260px] flex flex-col justify-between overflow-hidden`}
                data-testid={`service-card-${s.idx}`}
              >
                <div className="absolute -top-24 -left-24 h-56 w-56 rounded-full bg-teal-100/60 blur-3xl pointer-events-none group-hover:bg-teal-200/70 transition" />
                <div className="flex items-start justify-between relative">
                  <div className="font-mono-a text-[10px] uppercase tracking-[0.28em] text-teal-700">
                    Model / {s.idx}
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-slate-400 group-hover:text-teal-600 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition" />
                </div>
                <div className="relative">
                  <h3 className="font-display text-2xl sm:text-3xl font-bold text-slate-900 leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-4 text-slate-600 leading-relaxed max-w-[46ch]">
                    {s.body}
                  </p>
                </div>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
